/**
 *
 * Asynchronously loads the component for ProductEdit
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ProductEdit = lazyLoad(
  () => import('./index'),
  module => module.default,
);
